module.exports = __webpack_public_path__ + "static/eco-0a088d2813f9650a988762b5509d4181.png";